const mailServiceName = '/Notification'

export function mailService (http) {
    return {
        sendMail: (ReceiversUserProfileIds, subject, body) => {
            const parameters = {
                ReceiversUserProfileIds,
                subject,
                body                
            }

            return http.post(mailServiceName + '/SendEmail',  parameters )
        }
    
    }
}

